export default "__VITE_ASSET__hq5k1FUi__"